/**
 * CustomerPagination Component
 * Pagination controls for customer list
 */

import React from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';

interface CustomerPaginationProps {
  page: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}

export const CustomerPagination: React.FC<CustomerPaginationProps> = ({
  page,
  totalPages,
  onPrevious,
  onNext,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: { xs: 2, sm: 0 },
        mt: 2,
        px: { xs: 0, sm: 2 },
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          textAlign: { xs: 'center', sm: 'left' },
          fontSize: { xs: '0.8125rem', sm: '0.875rem' },
        }}
      >
        Page {page} of {totalPages || 1}
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          size="small"
          onClick={onPrevious}
          disabled={page <= 1}
          sx={{
            flex: { xs: 1, sm: 'none' },
            minHeight: { xs: 44, sm: 'auto' },
            fontSize: { xs: '0.875rem', sm: '0.8125rem' },
          }}
        >
          Previous
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={onNext}
          disabled={page >= totalPages}
          sx={{
            flex: { xs: 1, sm: 'none' },
            minHeight: { xs: 44, sm: 'auto' },
            fontSize: { xs: '0.875rem', sm: '0.8125rem' },
          }}
        >
          Next
        </Button>
      </Stack>
    </Box>
  );
};

export default CustomerPagination;
